import { Pipe, PipeTransform } from '@angular/core';
import { XsI18nPipe } from '@nx-fe/pipes';

@Pipe({
    name: 'dayOfWeekPipe'
})
export class DayOfWeekPipe implements PipeTransform {

    constructor(private saI18nPipe: XsI18nPipe) {
    }

    transform(day: number): any {
        return this.saI18nPipe.transform(`weekday_${day}`);
    }
}
